import React from 'react'
import portsman from '../images/SHENIMED_POR_01.png'
import winston from '../images/SHENIMED_WIN_01.png'
import winston2 from '../images/SHENIMED_WIN_02.png'
import monte from '../images/SHENIMED_MON_01.png'
import monte2 from '../images/SHENIMED_MON_02.png'
import camel from '../images/SHENIMED_CAM_01.png'
import { useLang } from "./Provider/LanguageProvider";

function NosMarques() {
  const { language } = useLang();

  return (
    <div id='nosmarques'>
      <div className='gap-marques'></div>
      <section className='section1'>
        {language === 'fr' ?
          <div className='welcome'>
            <span className='pre-title'>NOUS DISTRIBUONS</span>
            <h1>DES MARQUES DE RENOM</h1>
            <p>
              Notre portefeuille comprend plusieurs marques régionales et de renommées internationales.
              <br />
              <br />
              Nous imposons des standards élevés à la fois pour la qualité
              de nos tabacs et pour les conditions de leur production.
            </p>
          </div> : <div className='welcome'>
            <span className='pre-title'>WE DISTRIBUTE</span>
            <h1>RENOWNED BRANDS</h1>
            <p>
              Our portfolio includes several regional and internationally renowned brands.
              <br />
              <br />
              We set high standards both for the quality of our tobacco and the conditions of their production.
            </p>
          </div>
        }
      </section>
      <section className='section2'>
        {language === 'fr' ?
          <div className='container'>
            <p>
              Nous avons lancé nos activités avec notre marque leader, Portsman. En 17 ans, nous
              avons su introduire avec succès de nouvelles marques, élargissant notre offre avec passion
              et engagement.
              <br />
              <br />
              Aujourd’hui, nous sommes honorés de proposer une gamme diversifiée de cigarettes,
              conçue pour répondre aux attentes de nos consommateurs adultes.
            </p>
          </div> :
          <div className='container'>
            <p>
              We launched our activities with our flagship brand, Portsman. In 17 years, we have
              successfully introduced new brands, expanding our offerings with passion
              and commitment.
              <br />
              <br />
              Today, we are honored to offer a diverse range of cigarettes, designed to meet the
              expectations of our adult consumers.
            </p>
          </div>
        }
      </section>
      <section className='section3'>
        {language === 'fr' ?
          <div className='container'>
            <div className='marque' id='Portsman' data-aos="zoom-out">
              <div className='top-cont'>
                <img src={portsman} alt='portsman' />
                <h2>PORTSMAN Étoile</h2>
              </div>
              <div className='bottom-cont'>
                <p>La marque leader, reconnue dans tout le pays.</p>
              </div>
            </div>
            <div className='marque' id='Camel' data-aos="zoom-out">
              <div className='top-cont'>
                <img src={camel} alt='camelgit add ' />
                <h2>CAMEL</h2>
              </div>
              <div className='bottom-cont'>
                <p>Une marque internationale largement reconnue pour sa
                  qualité depuis plus de 100 ans.</p>
              </div>
            </div>
            <div className='marque' id='Winston' data-aos="zoom-out">
              <div className='top-cont'>
                <img src={winston} alt='winston' />
                <h2>WINSTON</h2>
              </div>
              <div className='bottom-cont'>
                <p>Une marque internationale de renom vendue à prix abordable.</p>
              </div>
            </div>
            <div className='marque' id='Winston' data-aos="zoom-out">
              <div className='top-cont'>
                <img src={winston2} alt='winston' />
                <h2>WINSTON Mentol</h2>
              </div>
              <div className='bottom-cont'>
                <p>Une marque internationale de renom vendue à prix abordable au goût mentholé.</p>
              </div>
            </div>
            <div className='marque' id='Montecarlo' data-aos="zoom-out">
              <div className='top-cont'>
                <img src={monte} alt='monte carlo' />
                <h2>MONTE CARLO</h2>
              </div>
              <div className='bottom-cont'>
                <p>Notre marque la plus apprécié.</p>
              </div>
            </div>
            <div className='marque' id='Montecarlo' data-aos="zoom-out">
              <div className='top-cont'>
                <img src={monte2} alt='monte carlo' />
                <h2>MONTE CARLO Berry Crush</h2>
              </div>
              <div className='bottom-cont'>
                <p>Le goût raffiné de la Monte Carlo avec une toute nouvelle saveur myrtille.</p>
              </div>
            </div>
          </div> :
          <div className='container'>
            <div className='marque' id='Portsman' data-aos="zoom-out">
              <div className='top-cont'>
                <img src={portsman} alt='portsman' />
                <h2>PORTSMAN Étoile</h2>
              </div>
              <div className='bottom-cont'>
                <p>The leading brand, recognized throughout the country.</p>
              </div>
            </div>
            <div className='marque' id='Camel' data-aos="zoom-out">
              <div className='top-cont'>
                <img src={camel} alt='camel' />
                <h2>CAMEL</h2>
              </div>
              <div className='bottom-cont'>
                <p>An international brand widely recognized for its quality for over 100 years.</p>
              </div>
            </div>
            <div className='marque' id='Winston' data-aos="zoom-out">
              <div className='top-cont'>
                <img src={winston} alt='winston' />
                <h2>WINSTON</h2>
              </div>
              <div className='bottom-cont'>
                <p>An internationally renowned brand sold at an affordable price.</p>
              </div>
            </div>
            <div className='marque' id='Winston' data-aos="zoom-out">
              <div className='top-cont'>
                <img src={winston2} alt='winston' />
                <h2>WINSTON Mentol</h2>
              </div>
              <div className='bottom-cont'>
                <p>An internationally renowned brand sold at an affordable price with a menthol flavor.</p>
              </div>
            </div>
            <div className='marque' id='Montecarlo' data-aos="zoom-out">
              <div className='top-cont'>
                <img src={monte} alt='monte carlo' />
                <h2>MONTE CARLO</h2>
              </div>
              <div className='bottom-cont'>
                <p>Our most beloved brand.</p>
              </div>
            </div>
            <div className='marque' id='Montecarlo' data-aos="zoom-out">
              <div className='top-cont'>
                <img src={monte2} alt='monte carlo' />
                <h2>MONTE CARLO Berry Crush</h2>
              </div>
              <div className='bottom-cont'>
                <p>The refined taste of Monte Carlo with an all-new blueberry flavor.</p>
              </div>
            </div>
          </div>
        }
      </section>
    </div>
  )
}

export default NosMarques